import {
  IExamResultTypeModel,
  ExamResultTypeModel,
} from './ExamResultTypeModel';
import { ModelRecord } from './Model';
import { ISyncModel, SyncModel } from '@common/models/SyncModel';
import {
  IBusinessLineModel,
  BusinessLineModel,
  ISpeciesModel,
  SpeciesModel,
} from '@common/models';
export interface IExamObservationModel extends ISyncModel {
  examObservationId: number;
  examCategoryId: number;
  examResultTypeId: number;
  name: string;
  sortOrder: number;
  examCategoryName: string;
  examCategorySortOrder: number;
  examResultType: IExamResultTypeModel | undefined;
  businessLineId: number;
  businessLine: IBusinessLineModel;
  rowIndex: number; //this is a client side property only to track index of the collection for inline editing.
  species: ISpeciesModel[];
}

export class ExamObservationModel
  extends SyncModel
  implements ModelRecord<IExamObservationModel>
{
  examObservationId: number;
  examCategoryId: number;
  examResultTypeId: number;
  name: string;
  sortOrder: number;
  examCategoryName: string;
  examCategorySortOrder: number;
  examResultType: ExamResultTypeModel | undefined;
  businessLineId: number;
  businessLine: BusinessLineModel;
  rowIndex: number;
  species: SpeciesModel[] = [];

  constructor(params?: Partial<IExamObservationModel>) {
    super(params);
    this.examObservationId = _.defaultTo(params?.examObservationId, 0);
    this.examCategoryId = _.defaultTo(params?.examCategoryId, 0);
    this.examResultTypeId = _.defaultTo(params?.examResultTypeId, 0);
    this.name = _.defaultTo(params?.name, '');
    this.sortOrder = _.defaultTo(params?.sortOrder, 0);
    this.examCategoryName = _.defaultTo(params?.examCategoryName, '');
    this.examCategorySortOrder = _.defaultTo(params?.examCategorySortOrder, 0);
    this.examResultType = params?.examResultType
      ? new ExamResultTypeModel(params.examResultType)
      : undefined;
    this.rowIndex = _.defaultTo(params?.rowIndex, 0);
    this.businessLineId = _.defaultTo(params?.businessLineId, 1); //default to Global
    this.businessLine = params?.businessLine
      ? new BusinessLineModel(params.businessLine)
      : new BusinessLineModel({ businessLineId: 1, name: 'Global' });
    _.map(params?.species, (s) => {
      this.species.push(new SpeciesModel(s));
    });
  }
}
